import React from "react";
import {Alert, Box, LinearProgress} from "@mui/material";
import {Responsive, WidthProvider} from "react-grid-layout";
import {
    breakpoints,
    cols,
    DRAGGABLE_CANCEL_SELECTORS,
    IDS,
} from "./dashboardUtils";

const ResponsiveGridLayout = WidthProvider(Responsive);

export default function DashboardGrid({layouts, items, loading, err}) {
    return (
        <>
            <style>{`
          .react-grid-item.react-draggable-dragging {
            z-index: 9999 !important;
            transform: scale(1.02);
            transition: box-shadow 120ms ease;
            box-shadow: 0 16px 40px rgba(0,0,0,0.18);
          }
          .react-grid-item > .react-resizable-handle::after {
            border-right: 2px solid rgba(0,0,0,0.2);
            border-bottom: 2px solid rgba(0,0,0,0.2);
          }
        `}</style>

            {err && (
                <Alert severity="error" sx={{mb: 2}}>
                    {err}
                </Alert>
            )}

            {loading && !err && (
                <Box sx={{my: 2}}>
                    <LinearProgress/>
                </Box>
            )}

            <ResponsiveGridLayout
                className="layout"
                layouts={layouts}
                breakpoints={breakpoints}
                cols={cols}
                rowHeight={130}
                margin={[16, 16]}
                containerPadding={[0, 0]}
                compactType={null}
                isDraggable={false}
                isResizable={false}
                draggableCancel={DRAGGABLE_CANCEL_SELECTORS}
                preventCollision
                useCSSTransforms
            >
                {IDS.map((id) => (
                    <div key={id}>{items[id]}</div>
                ))}
            </ResponsiveGridLayout>
        </>
    );
}
